import { Component, OnInit, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-modal-alerta',
  templateUrl: './modal-alerta.component.html',
  styleUrls: ['./modal-alerta.component.scss']
})
export class ModalAlertaComponent implements OnInit {
  @Input() tipo: string = 'success';
  @Input() mensagem: string;
  @Input() detalhes: any;
  @Input() servidorInativo: string = '';

  constructor(public bsModalRef: BsModalRef) {}

  ngOnInit() {
    //console.log('this.detalhes');
    //console.log(this.detalhes);
    //console.log('this.tipo');
    //console.log(this.tipo);
  }

  /*
export enum TipoAlerta {
  PERIGO = 'danger',
  SUCESSO = 'success',
  AVISO = 'warning',
  INFO = 'info'
}
*/

  tipoBr() {
    switch (this.tipo) {
      case 'success':
        return 'SUCESSO';
        break;
      case 'danger':
        return 'ERRO';
        break;
      case 'warning':
        return 'ATENÇÃO';
        break;
      case 'info':
        return 'INFORMAÇÃO';
        break;
      default:
        break;
    }
  }

  onFechar() {
    this.bsModalRef.hide();
  }

  getDetalhes(): string {
    if (this.detalhes) {
      if (this.detalhes instanceof HttpErrorResponse) {
        return this.detalhes.message;
      } else {
        return this.detalhes.toString();
      }
    }
  }
}
